/**
 * Bank Accounts Routes
 *
 * URL Pattern: /:organisation/banking/bank-accounts
 */

import transactions from './bank-transactions.js';
import imports from './bank-imports.js';
import bankStatements from './bank-statements.js';

export default [
    {
        path: '/:organisation/banking/bank-accounts/archive',
        component: () => import('@/pages/[organisation]/banking/bank-accounts/archive.vue'),
        name: 'banking.bank-accounts.archived-bank-accounts',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-account.update-bank-account',
        },
        children: [
            {
                path: ':id',
                component: () => import('@/pages/[organisation]/banking/bank-accounts/archive/[id].vue'),
                name: 'banking.bank-accounts.view-archived-bank-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.banking.bank-account.update-bank-account',
                },
            },
        ],
    },
    {
        path: '/:organisation/banking/bank-accounts',
        component: () => import('@/pages/[organisation]/banking/bank-accounts.vue'),
        name: 'banking.bank-accounts.search-bank-accounts',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-account.view-bank-accounts',
        },
        children: [
            {
                path: 'new',
                component: () => import('@/pages/[organisation]/banking/bank-accounts/new.vue'),
                name: 'banking.bank-accounts.create-bank-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.banking.bank-account.create-bank-account',
                },
            },
            {
                path: ':id',
                component: () => import('@/pages/[organisation]/banking/bank-accounts/[id].vue'),
                name: 'banking.bank-accounts.view-bank-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.banking.bank-account.view-bank-accounts',
                },
                children: [...transactions, ...imports, ...bankStatements],
            },
            {
                path: ':id/edit',
                component: () => import('@/pages/[organisation]/banking/bank-accounts/[id]/edit.vue'),
                name: 'banking.bank-accounts.update-bank-account',
                meta: {
                    loginRequired: true,
                    permission: 'access.banking.bank-account.update-bank-account',
                },
            },
        ],
    },
];
